
import { Separator } from "@/components/ui/separator";

interface CandidateInfoSectionProps {
  name: string;
  function: string;
  synthesis: string;
}

export const CandidateInfoSection = ({ name, function: jobFunction, synthesis }: CandidateInfoSectionProps) => {
  if (!name && !jobFunction && !synthesis) return null;
  
  return (
    <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
      {name && (
        <h2 className="text-xl font-semibold text-gray-800 mb-1">{name}</h2>
      )}
      
      {jobFunction && (
        <h3 className="text-md text-gray-600 mb-2">{jobFunction}</h3>
      )}
      
      {synthesis && (
        <>
          <Separator className="my-2" />
          <p className="text-sm text-gray-700 mt-2">{synthesis}</p>
        </>
      )}
    </div>
  );
};
